export const horsesConstants = {
    CHANGE_SEARCH: 'CHANGE_SEARCH',
    CLEAR_SEARCH: 'CLEAR_SEARCH',
    SET_FILTERS: 'SET_FILTERS',
    CLEAR_FILTERS: 'CLEAR_FILTERS',
    UPDATE_FILTER: 'UPDATE_FILTER'
};
